// gif
export { default as coffee } from './coffee-animation.gif';
export { default as TipLightBulbOn } from './tip-light-bulb-on.png';
